module.exports = __webpack_public_path__ + "img/globe.1589d870.svg";